import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStoreLogin } from "../paginas/Login/useStoreLogin.js";

export default function AutoReq() {
  const isAuth = useStoreLogin((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
